import ManagedAnimation from '../ManagedAnimation';

/**
 * Timer class, used for managing when to update elements and their progress during an animation.
 * @abstract
 * @alias Animation.Timer.Timer
 * @memberOf Animation.Timer
 * @class
 */
export default class Timer extends ManagedAnimation {
  constructor() {
    super();
    // region Define fields.
    /**
     * Callback which is triggered for every animation update.
     * @type {TickerCallback|null}
     * @private
     */
    this._tickerCallback = null;
    // endregion
  }

  /**
   * Callback used to notify the {@link Animation} class of an update.
   * @callback TickerCallback
   * @param {number} percentComplete
   * @param {object} data
   */
  /**
   * Set the ticker callback closure, used for updating the animation progress.
   * @param {TickerCallback|null} callback
   */
  setTickerCallback(callback) {
    this._tickerCallback = callback;
    this.tick(0);
  }

  /**
   * Check to see if a ticker callback has been set.
   * @return {boolean} True if a ticker callback has been set.
   */
  hasTickerCallback() {
    return this._tickerCallback !== null;
  }

  /**
   * Ticks the {@link Animation.Animation} class.
   * @param {number} percent Animation completion as a decimal.
   * @param {object} data
   * @protected
   */
  tick(percent, data = {}) {
    if (this.hasTickerCallback()) {
      this._tickerCallback(percent, data);
    }
  }
};



// WEBPACK FOOTER //
// ./src/class/Animation/Timer/Timer.js